module.exports = __webpack_public_path__ + "media/phase-3-complete.b292963f.mp4";